import { sendGet, sendPost } from "./generic"

export const getNotifications = () => {
    return sendGet("Notifications")
}
